document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    const productMain = select.closest('.product-main');
    const gallery = productMain?.querySelector('.product-gallery');
    const price = form?.closest('.product-details')?.querySelector('[data-product-price]');
    const button = form?.querySelector('[data-add-to-cart]');

    const showVariantMedia = (mediaId) => {
      if (!gallery || !mediaId) return;
      const target = gallery.querySelector(`[data-media-id="${CSS.escape(String(mediaId))}"]`);
      if (!target) return;

      gallery.querySelectorAll('.product-media').forEach((media) => {
        media.classList.toggle('product-media--active', media === target);
      });

      // Keep the chosen variant image at the top of the gallery without
      // removing the remaining product images below it.
      target.scrollIntoView?.({ block: 'nearest' });
    };

    const sync = () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;

      if (price && option.dataset.price) price.textContent = option.dataset.price;

      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }

      if (option.dataset.mediaId) showVariantMedia(option.dataset.mediaId);

      // Keep the selected variant in the URL so refresh/share preserves it.
      if (option.dataset.variantUrl && window.history?.replaceState) {
        const url = new URL(option.dataset.variantUrl, window.location.origin);
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      }
    };

    select.addEventListener('change', sync);
    sync();
  });

});
